import { render, staticRenderFns } from "./CardResv.vue?vue&type=template&id=0444f8bd&scoped=true"
import script from "./CardResv.vue?vue&type=script&lang=js"
export * from "./CardResv.vue?vue&type=script&lang=js"
import style0 from "./CardResv.vue?vue&type=style&index=0&id=0444f8bd&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0444f8bd",
  null
  
)

export default component.exports